import { cortexApi } from '@/api/apis'

const authService = {
  /**
   * Activates a user account with the given token and password.
   * @param token The DataProtection token that identifies this user
   * @param password The new password to be set
   * @param passwordConfirmation The confirmation of the new password
   * @returns The token of the user
   */
  activateAccount: async ({ token, password, passwordConfirmation }) => {
    const { data } = await cortexApi.post('/account/activate', {
      token,
      password,
      passwordConfirmation,
    })

    return data
  },

  /**
   * Gets the activation info for a given token.
   * @param {string} token The cryptographically protected token to request validation info for
   * @returns Activation info describing if this token is already used for activation or not
   */
  getActivationInfo: async (token) => {
    const { data } = await cortexApi.get('/account/activation-info', {
      params: { token },
    })
    return data
  },
}

export { authService }
